import {
  ExclamationTriangleIcon,
  ClockIcon,
  ChatBubbleLeftRightIcon,
} from '@heroicons/react/24/outline';
import BasicModal from '../../../components/modals/BasicModal';
import { useEffect } from 'react';
import { Mixpanel } from '../../../services/Mixpanel';
import { useTypeform } from '../../../hooks/useTypeform';

export const TooManyPacketsModal = ({ showModal, setShowModal, error }) => {
  useEffect(() => {
    Mixpanel.track('Too many packets error served', { ...error });
  }, []);
  const typeformUrl = useTypeform('https://form.typeform.com/to/ewEbB3O7');

  const nextSunday = () => {
    const now = new Date();
    const dayOfWeek = now.getUTCDay(); // 0 = Sunday, 1 = Monday, etc.
    const daysUntilNextSunday = dayOfWeek === 0 ? 7 : 7 - dayOfWeek;

    const nextSunday = new Date(now);
    nextSunday.setUTCDate(now.getUTCDate() + daysUntilNextSunday);
    nextSunday.setUTCHours(0, 0, 0, 0); // Set to midnight UTC

    return nextSunday.toLocaleString('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short',
    });
  };

  return (
    <BasicModal
      showModal={showModal}
      setShowModal={setShowModal}
      title={'Need more resources?'}
      iconBackground='bg-amber-100'
      icon={<ExclamationTriangleIcon className='h-6 text-amber-500' />}>
      <div className='space-y-6 pt-4 mx-4'>
        {/* Main explanation with ExclamationTriangle icon */}
        <div className='flex items-start space-x-3'>
          <div className='flex-shrink-0'>
            <ExclamationTriangleIcon className='h-5 w-5 text-gray-900 mt-0.5' />
          </div>
          <p className='text-sm text-gray-900'>
            Heads up! You've exceeded the maximum number of resources that can be created per week
            on your current plan.
          </p>
        </div>

        {/* Reset date section with Clock icon */}
        <div className='flex items-start space-x-3'>
          <div className='flex-shrink-0'>
            <ClockIcon className='h-5 w-5 text-gray-900 mt-0.5' />
          </div>
          <p className='text-sm text-gray-900'>
            You'll be able to start generating resources again on {nextSunday()}.
          </p>
        </div>

        {/* Contact section with ChatBubble icon */}
        <div className='flex items-start space-x-3'>
          <div className='flex-shrink-0'>
            <ChatBubbleLeftRightIcon className='h-5 w-5 text-gray-900 mt-0.5' />
          </div>
          <p className='text-sm text-gray-900'>
            If you feel this is in error, please{' '}
            <a
              href={typeformUrl}
              target='_blank'
              className='text-emerald-600 hover:text-emerald-700 underline'>
              contact us
            </a>
            .
          </p>
        </div>

        {/* Button */}
        <div className='flex flex-col space-y-3 pt-4'>
          <button
            onClick={() => setShowModal(false)}
            className='w-full text-sm font-medium text-emerald-600 hover:text-emerald-700'>
            Close
          </button>
        </div>
      </div>
    </BasicModal>
  );
};
